import { render, staticRenderFns } from "./CrewContact.vue?vue&type=template&id=11677723&scoped=true&"
import script from "./CrewContact.vue?vue&type=script&lang=js&"
export * from "./CrewContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11677723",
  null
  
)

export default component.exports